import React, { PureComponent } from 'react';

class TableHeader extends PureComponent {

    render() {
        return (
            <thead>
                <tr>
                    <th>
                        <label>Nº</label>
                    </th>
                    <th>
                        <label>NOMBRE</label>
                    </th>
                    <th>
                        <label>VINCULO</label>
                    </th>
                    <th>
                        <label>LIMITE</label>
                    </th>
                    <th>
                    </th>
                    <th>
                    </th>
                </tr>
            </thead >
            );
    }
};

export default TableHeader;